module.exports = __webpack_public_path__ + "img/appAsset-brand--facturapi.f2cfa933.svg";